"use client";
import { Box, BoxProps, styled } from "@mui/material";

const StyledBox = styled(Box)`
  background: linear-gradient(
    90deg,
    rgba(255, 217, 105, 0) 0%,
    #ffd969 47.6%,
    rgba(255, 217, 105, 0) 100%
  );
  opacity: 0.5;
`;
const StyledBox2 = styled(Box)`
  background: linear-gradient(
    0deg,
    rgba(255, 217, 105, 0) 0%,
    #ffd969 47.6%,
    rgba(255, 217, 105, 0) 100%
  );
  opacity: 0.5;
`;

type DividerGradientProps = {
  isVertical: boolean;
} & BoxProps;

export function DividerGradient(props: DividerGradientProps) {
  const { isVertical, ...other } = props;
  if (isVertical) return <StyledBox2 width="1px" height="100%" {...other} />;
  else return <StyledBox width="100%" height="1px" {...other} />;
}
